import { render, staticRenderFns } from "./BaseDropdownFloatingButton.vue?vue&type=template&id=1f516d66&scoped=true"
import script from "./BaseDropdownFloatingButton.vue?vue&type=script&lang=js"
export * from "./BaseDropdownFloatingButton.vue?vue&type=script&lang=js"
import style0 from "./BaseDropdownFloatingButton.vue?vue&type=style&index=0&id=1f516d66&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f516d66",
  null
  
)

export default component.exports